module.exports = __webpack_public_path__ + "img/shape.490a3b1f.svg";